export default __webpack_public_path__ + "static/media/Gatsby-Monogram.1930007f.svg";